module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "welcome-module"
    }
  }, [_c('div', {
    staticClass: "bg-brand text-white p-8 shadow-lg pointer-events-auto md:rounded"
  }, [_c('div', {
    staticClass: "w-full mb-8"
  }, [_c('img', {
    staticClass: "block mb-8",
    attrs: {
      "src": require('../assets/img/lcf_csf_lockup.png')
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "text-2xl font-bold mb-4 pt-8 border-t"
  }, [_vm._v("Fashion & Sustainability")]), _vm._v(" "), _c('div', {
    staticClass: "text-2xl"
  }, [_vm._v("Understanding Luxury Fashion in a Changing World")])]), _vm._v(" "), (_vm.addYourselfVisible) ? _c('div', [_c('div', [_c('csf-button', {
    staticClass: "mb-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.$emit('add')
      }
    }
  }, [_vm._v("Add yourself")])], 1), _vm._v(" "), _c('div', [_c('csf-button', {
    staticClass: "mb-4",
    on: {
      "click": _vm.showRandom
    }
  }, [_vm._v("Show random learner")])], 1)]) : _c('div', [_c('div', [_c('csf-button', {
    staticClass: "mb-4",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.showRandom
    }
  }, [_vm._v("Show random learner")])], 1), _vm._v(" "), _c('div', [_c('csf-button', {
    staticClass: "mb-4",
    on: {
      "click": _vm.openFL
    }
  }, [_c('span', {
    staticClass: "pr-3"
  }, [_vm._v("←")]), _vm._v("Return to FutureLearn")])], 1)]), _vm._v(" "), _c('div', [_c('csf-button', {
    staticClass: "md:hidden",
    on: {
      "click": function($event) {
        _vm.$emit('close')
      }
    }
  }, [_vm._v("Browse map")])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-062bf4f9","transformToRequire":{"video":["src","poster"],"source":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./source/components/WelcomeModule.vue
// module id = 164
// module chunks = 0